import { Component, OnInit } from '@angular/core';
import { TrpcService } from '../services/trpc/trpc.service';
import { MessageService } from 'primeng/api';
import { CreateInvoiceRequest, CreateInvoiceRequestParams } from '../../../../express-tRPC/src/api/invoices/types';
import { Tenant } from '../../../../express-tRPC/src/api/tenants/types-generic';

@Component({
  selector: 'app-dev-jab',
  templateUrl: './dev-jab.component.html',
  styleUrl: './dev-jab.component.scss'
})
export class DEVJABComponent implements OnInit {
  generatingTestInvoice: boolean = false;

  // Pull Tenant testing properties
  pullTenantSuite: string = '100';
  pullTenantAccount: string = '1006';
  pullTenantLocation: string = '';
  pullingTenant: boolean = false;
  pullTenantResponse: any = null;
  pullTenantError: string = '';

  constructor(
    private trpcService: TrpcService,
    private messageService: MessageService
  ) { }

  async ngOnInit() {
    // Get current location from observable
    this.trpcService.currentLocationObservable.subscribe((location) => {
      if (location) {
        this.pullTenantLocation = location;
        console.log('Current location set to:', location);
      } else {
        // Default to 99998 if no location is set
        this.pullTenantLocation = '99998';
      }
    });
  }

  async createTestMonthlyInvoice() {
    if (this.generatingTestInvoice) {
      return;
    }

    this.generatingTestInvoice = true;
    
    try {
      // Create test data similar to the selected code
      const currentDate = new Date();
      
      // Test invoice line items
      const invoiceItems = [
        {
          qty: "1",
          description: "Monthly Parking Fee",
          textDescription: "Monthly Parking Fee",
          unitprice: "150.00",
          line_ar_type: "Parking"
        },
        {
          qty: "1", 
          description: "Test Service Fee",
          textDescription: "Test Service Fee",
          unitprice: "25.00",
          line_ar_type: "Service"
        }
      ];

      // Test invoice request parameters
      const CreateInvoiceRequestParams: CreateInvoiceRequestParams = {
        type: "Monthly",
        suite: "101",
        invoicenotes: "Test monthly invoice generated from dev component",
        accountnumber: "12345",
        billingMonth: currentDate.toLocaleString('default', { month: 'long' }) + "-" + currentDate.getFullYear(),
        date: currentDate.toLocaleDateString("en-US"),
        items: invoiceItems
      };

      // Mock tenant data for testing
      const mockTenant: Tenant = {
        tid: 1,
        suite: 101,
        account: 12345,
        lid: 1,
        name: "Test Company Inc.",
        billto: "Test Company Inc.",
        street_address: "123 Test Street",
        city: "Test City",
        state: "TS",
        zip: "12345",
        email: "test@testcompany.com",
        session: "",
        pendingHide: "",
        group_name: "Test Group",
        group_id: "1"
      };

      const createInvoiceRequest: CreateInvoiceRequest = {
        tickets: [],
        tenant: mockTenant,
        comments: 'Test invoice generated from dev component',
        params: CreateInvoiceRequestParams
      };

      // Call the same tRPC method as the selected code
      const response = await this.trpcService.trpc.monthly_invoice.createWebInvoiceFromUI.mutate(createInvoiceRequest);

      console.log('Test createWebInvoiceFromUI response:', response);
      this.generatingTestInvoice = false;
      
      this.messageService.add({
        severity: "success",
        summary: "Success",
        detail: "Test monthly invoice created successfully. Invoice ID: " + response,
      });

    } catch (error: any) {
      this.generatingTestInvoice = false;
      console.error('Error creating test monthly invoice:', error);
      this.messageService.add({
        severity: "error",
        summary: "Error",
        detail: error.message || "Failed to create test monthly invoice",
      });
    }
  }

  async pullTenantData() {
    if (this.pullingTenant) {
      return;
    }

    if (!this.pullTenantSuite || !this.pullTenantAccount) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Suite and Account are required'
      });
      return;
    }

    this.pullingTenant = true;
    this.pullTenantResponse = null;
    this.pullTenantError = '';

    try {
      console.log('Pulling tenant data for:', {
        suite: this.pullTenantSuite,
        account: this.pullTenantAccount,
        location: this.pullTenantLocation
      });

      // Call the getAccountDetails which internally uses pullTenant
      const response = await this.trpcService.trpc.authRouter.getAccountDetails.query({
        suite: this.pullTenantSuite,
        account: this.pullTenantAccount
      });

      console.log('Pull Tenant Response:', response);
      this.pullTenantResponse = response;

      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Tenant data retrieved successfully'
      });

    } catch (error: any) {
      console.error('Error pulling tenant data:', error);
      this.pullTenantError = error.message || 'Failed to pull tenant data';
      this.pullTenantResponse = null;

      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: this.pullTenantError
      });
    } finally {
      this.pullingTenant = false;
    }
  }

  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text).then(() => {
      this.messageService.add({
        severity: 'info',
        summary: 'Copied',
        detail: 'JSON copied to clipboard'
      });
    });
  }

  formatJSON(obj: any): string {
    return JSON.stringify(obj, null, 2);
  }
}
